
import { Component, Vue, Prop } from 'vue-property-decorator';
import StepCompletedCheckbox from './StepCompletedCheckbox.vue';
import CalendarIconSvg from '@/iconSVG/CalendarIconSvg.vue'
import CalendarIconSvgChecked from '@/iconSVG/CalendarIconSvgChecked.vue'

@Component({
    components:{
        StepCompletedCheckbox,
        CalendarIconSvg,
        CalendarIconSvgChecked
    }
})

export default class  CalendarIcon extends Vue {

    @Prop({required: false})
    status!: string;

    @Prop({required: false})
    stepTitleClass!: string;

    @Prop({required: false})
    active!: boolean;

    @Prop({required: false})
    ready!: boolean;

    @Prop({required: true})
    order!: number;

    @Prop({required: false})
    stepTitle!: string;


    public action(){
        this.$emit('action')
    }
    public completed(checked) {
        this.$emit('completed', this.order-1, checked)
    }
}
